/**
 * Transform booking parts from API response into ProductInfo objects.
 *
 * Loops through all booking parts and groups them with fancy black magic
 * to recognize them as products and group it as "Product Info" items.
 *
 */
export function transformProductInfos(bookingParts: ApiBookingPart[], response: ApiSchema['BookingResponse'], exchangeableGroups: ExchangeableGroup[]): ProductInfo[] {
    return [
        ...transformProductInfosActivity(bookingParts, response),
        ...transformProductInfosP2P(bookingParts, response, exchangeableGroups),
        ...transformProductInfosAccommodation(bookingParts, response),
    ];
}
